<template>
  <bk-page class="settingsPage" pageType="navPage" :navBarInfo="navBarInfo">
		<bk-view class="view-container">
			<bk-form :formConfig="formConfig" />
		</bk-view>

		<transition name="rightFadeIn">
      <changePassword 
				v-if="showPage==='changePassword'" 
				@close="setShowPage()" 
			/>
    </transition>


		<transition name="rightFadeIn">
      <myAddress 
				v-if="showPage==='myAddress'" 
				@close="setShowPage()" 
			/>
    </transition>

		<transition name="rightFadeIn">
      <deleteAccount 
				v-if="showPage==='deleteAccount'" 
				@close="setShowPage()" 
			/>
    </transition>

	</bk-page>
</template>

<script>
	import changePassword from './changePassword/changePassword.vue';
	import myAddress from './myAddress/myAddress.vue';
	import deleteAccount from './deleteAccount/deleteAccount.vue';
	
	export default {
		name: 'settings',
		components:{changePassword, myAddress, deleteAccount},
		data (){
			return {
				navBarInfo: {
					langCode_title:'userInfo_settings_title',
					backFlag: true,
				},
				showPage:'',
			};
		},
		computed:{
			formConfig (){
				return {
					scene:'skipPage',
					items:[
						{e:'input', langCode:'userInfo_settings_address', key:'myAddress', icon:'icon-dingwei', iconSize:'24px', isLink:true, event:{ click: this.formItemClick } },
						{e:'input', langCode:'userInfo_settings_password', key:'changePassword', icon:'icon-mima', isLink:true, event:{ click: this.formItemClick } },
						{e:'input', langCode:'userInfo_settings_deleteUser', key:'deleteUser', icon:'icon-zhuxiao', isLink:true, event:{ click: this.formItemClick } },
					]
				};
			}
		},
		methods:{
			formItemClick ({ column }){
				if (column.key === 'deleteUser') {
					this.setShowPage('deleteAccount');
					return;
				}

				this.setShowPage(column.key);
			},
			setShowPage (showPage=''){
				this.showPage = showPage;
			}
		}
		
	};
</script>

<style lang="less">
@import './settings.less';
</style>